import { useSelector } from 'react-redux';

import {
  AnalyticsEventNames,
  Categories,
  DataLayerEventName,
  pushToAdobeDataLayer,
} from '@app/services/adobeDataLayer';
import { AEMContentProvider, AemFeature, createAemUrl } from '@app/components/AdobeExperienceFragments';
import { selectConfig, selectLocale, selectUserInfo } from '@app/redux';

const MyViasatAppAd = () => {
  const { aemBaseUrl } = useSelector(selectConfig);
  const {
    locale: { userLocale },
  } = useSelector(selectLocale);
  const {
    loading,
    userInfo: { accountType },
  } = useSelector(selectUserInfo);

  const handleClick = () => {
    pushToAdobeDataLayer({
      event: DataLayerEventName.LINK,
      event_name: DataLayerEventName.LINK,
      event_label: AnalyticsEventNames.DownloadAppIconClicked,
      event_category: Categories.DownloadAppIcon,
    });
  };

  if (loading) {
    return null;
  }

  return (
    <button
      onClick={handleClick}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
      }}
    >
      <AEMContentProvider
        src={createAemUrl({
          baseUrl: aemBaseUrl,
          locale: userLocale,
          feature: AemFeature.MV_APP_AD,
          accountType,
        })}
      />
    </button>
  );
};

export default MyViasatAppAd;
